'use client';

import { HeaderContainer } from '@/components/NewHeader/HeaderContainer';
import { useNewHeader } from '@/featureFlags/newHeader';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export default function NewHeader() {
  const newHeader = useNewHeader();
  const pathname = usePathname();

  //Send header experiment event to Google Analytics
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: 'header_experiment',
      variant: newHeader ? 'new_header' : 'old_header',
    });
  }, [newHeader]);

  if (pathname.includes('resetting') || pathname.includes('login')) {
    return null;
  }

  if (!newHeader) {
    return null;
  }

  return <HeaderContainer />;
}
